import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { SUPPORTED_LOCALES } from "../app/locale";

import it from "./locales/it.json";
import en from "./locales/en.json";
import de from "./locales/de.json";

i18n.use(initReactI18next).init({
  resources: {
    it: { translation: it },
    en: { translation: en },
    de: { translation: de },
  },
  // Solo le lingue con i testi legali approvati (informativa, consensi, Privacy
  // Policy): una lingua fuori elenco non viene mai attivata, resta l'inglese.
  supportedLngs: [...SUPPORTED_LOCALES],
  lng: "en",
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});

export default i18n;
